<template>
  <div class="resource">
    <el-row :gutter="20">
      <el-col :span="22" :offset="1">
        <h1 class="title">云分享教案课件</h1>
        <div class="condition">
          <el-form
            :model="resourceCondition"
            ref="resourceConditionForm">
            <!--教案课件名称-->
            <div class="resourceCondition">
              <el-form-item class="resourceName" label="教案课件名称：" label-width="130px">
                <el-input
                  size="small"
                  v-model="resourceCondition.CourseName"
                  placeholder="请输入名称"></el-input>
              </el-form-item>
              <el-form-item class="resourceBtns">
                <el-button size="small" type="primary" @click="searchResource">查询</el-button>
                <el-button size="small" @click="resetConditionForm">重置</el-button>
              </el-form-item>
            </div>
            <!--            省市学校-->
            <el-row class="resourceCondition" :gutter="15">
              <el-col :span="10">
                <el-form-item label="省-市-学校/单位：" label-width="130px">
                  <el-autocomplete
                    clearable
                    size="small"
                    v-model="selProvince"
                    class="inline-input"
                    :fetch-suggestions="fetchProvinceData"
                    placeholder="请输入省份名"
                    @select="selProvinceData"
                    @clear="clearProvinceData"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item>
                  <el-autocomplete
                    clearable
                    size="small"
                    v-model="selCity"
                    class="inline-input"
                    :fetch-suggestions="fetchCityData"
                    placeholder="请输入城市名"
                    @select="selCityData"
                    @clear="clearCityData"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item>
                  <el-autocomplete
                    clearable
                    size="small"
                    v-model="selSchool"
                    class="inline-input"
                    :fetch-suggestions="fetchSchoolData"
                    placeholder="请输入学校名"
                    @select="selSchoolData"
                    @clear="clearSchoolData"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
<!--        @filter-change="resourceTableColumnFilter"-->
        <el-table
          :highlight-current-row="true"
          ref="resourceTable"
          @cell-click="cellClick"
          header-row-class-name="tableHeader"
          :stripe="true"
          :border="false"
          @sort-change="resourceTableColumnSort"
          :data="resource">
          <el-table-column
            prop="ResourcesName"
            label="名称" width="300" align="left">
            <template slot-scope="scope">
              <div class="file_li">
                <div class="file_yx file_icon" :style="{'background-color': scope.row.Color}">{{scope.row.Extension}}</div>
                <div class="file_yx file_name">{{scope.row.ResourcesName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Size" label="文件大小" width="100">
          </el-table-column>

         <el-table-column label="精品标记" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.QualityMark == 1" size="small" type="info" effect="dark">精品</el-tag>
            </template>
          </el-table-column>
          <!--省市学校-->
          <el-table-column
            prop="SchoolName"
            sortable="custom"
            label="省-市-学校/单位"
            min-width="160">
          </el-table-column>
          <!--作者-->
<!--          :filter-method="(val,row,column)=>val===row.TeacherID"-->
          <el-table-column
            width="100"
            prop="TeacherName"
            label="作者">
          </el-table-column>
          <!--时间-->
          <el-table-column
            sortable="custom"
            width="160"
            prop="SharedTime"
            label="分享时间">
          </el-table-column>
          <!--状态-->
          <el-table-column
            sortable="custom"
            width="120"
            prop="ShowState"
            label="状态">
            <template slot-scope="scope">
              {{scope.row.ShowState == 1 ? '已添加' : '未添加'}}
            </template>
          </el-table-column>
          <!--操作区-->
          <el-table-column
            width="160"
            fixed="right"
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click.prevent="downFile(scope.row.ResourcesPath,scope.row.ResourcesName)" style="color: #00be00;">下载</el-button>
              <el-button
                v-if="scope.row.ShowState==1 && scope.row.TeacherId != loginTeacherID"
                type="text" size="medium"
                @click="deleteResourceTeachingPlan(scope)">
                取消添加
              </el-button>
              <el-button
                v-if="scope.row.ShowState==0 && scope.row.TeacherId != loginTeacherID"
                type="text" size="medium"
                @click="addResourceTeachingPlan(scope)">
                添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="resourcePaginationChange"
          :page-size="resourcePagination.pageSize"
          :pager-count="resourcePagination.pageCounter"
          layout="prev, pager, next,jumper"
          :total="resourcePagination.total">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "SharedResource",
    //定义接收的属性
    props: {
      chapterId: [String, Number], // 章节ID
      TeachingPlanId: [String, Number], //课时ID
    },
    data() {
      return {
        /*云教案课件数据开始*/
        resource: [],
        //列表分页信息
        resourcePagination: {
          pageSize: 1,//每页多少行
          total: 0,//总行数
          pageCounter: 11,//折叠数,只能为单数....神奇啊
        },
        //搜索条件.
        //重置与第一次搜索时的条件
        resourceCondition: {
          CurrentPage: 1,//搜索第几页
          PageSize: 10,//每页多少行
          ChapterID: this.chapterId,
          TeachingPlanID: this.TeachingPlanId,
          CourseName: '',
          ProvinceID: '',
          CityID: '',
          AreaID: '',
          SchoolID: '',
          //过滤的几个字段
          TeacherID: '', // 作者id.
          SourceType: '', //类型：0非精品、1精品、空全部.
          Sort: [
            {SortField: "SharedTime", SortType: "desc"}
          ]
        },
        provinceData: [],//省data
        selProvince: '',//当前选择的省份.
        cityData: [], //市data
        selCity: '', //当前选择的市.
        schoolData: [],
        selSchool: '',

        teacherFilters: [],//字段过滤作者
        stateFilters: [],///字段过滤  状态

        /*数据结束*/
        loginTeacherID : localStorage["TeacherID"],
      }
    },
    methods: {
      // 获取分享的教案课件
      getResourceListAuditedBySearchPage() {
        this.axios.post(window.url + 'GetResourceListAuditedBySearchPage', this.resourceCondition)
          .then(res => {

            if (res.data.result == 200) {
              let resData = res.data.data;
              this.resource = resData.dataList;
              this.resourcePagination.total = resData.totalSize;
              this.resourcePagination.pageSize = resData.pageSize;
              this.expertFilters = resData.expertFilters;
              this.sourceFilters = resData.sourceFilters;
              this.stateFilters = resData.stateFilters;
              this.teacherFilters = resData.teacherFilters;
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(error => {
            this.$message.error(error);
          })
      },
      //分页显示
      resourcePaginationChange(e) {
        this.resourceCondition.CurrentPage = +e;
        this.getResourceListAuditedBySearchPage();
      },
      //取消使用
      deleteResourceTeachingPlan(scope) {
        let condition = {
          TeachingPlanID: this.TeachingPlanId,//备课信息id、
          ResourceID: scope.row.ResourcesID,//精品资源id、
          // ChapterID: this.chapterId,//绑定的章节id
        }
        this.axios.post(window.url + 'DeleteResourceTeachingPlan', condition)
          .then(res => {
            if (res.data.result === 200) {
              this.$message.success('操作成功');
              this.getResourceListAuditedBySearchPage();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(error => {
            //异常
            this.$message.error('无响应,请稍后再试！');
          })
      },
      //使用云分享教案课件
      addResourceTeachingPlan(scope) {
        let condition = {
          TeachingPlanID: this.TeachingPlanId,//备课信息id、
          ResourceID: scope.row.ResourcesID,//精品资源id、
          // ChapterID: this.chapterId,//绑定的章节id
        }
       // return;
        this.axios.post(window.url + 'AddResourceTeachingPlan', condition).then(
          res => {
            if (res.data.data) {
              this.$message.success('操作成功');
              this.getResourceListAuditedBySearchPage();
            } else {
              this.$message.error(res.data.message);
            }
          }
        );
      },
      cellClick(row, column) {

        if (column.property == 'ResourcesName') {
          window.open(row.ResourcesPath,'blank');
        }
      },
      // 搜索精品资源,单写是为了验证,备留
      searchResource() {
        this.$refs['resourceConditionForm'].validate((valid) => {
          if (valid) {
            this.getResourceListAuditedBySearchPage();
          } else {
            return false;
          }
        });
      },
      //搜索全部重置
      resetConditionForm() {

        // this.$refs['resourceConditionForm'].resetFields();
        this.resourceCondition = {
          CurrentPage: 1,//搜索第几页
          PageSize: 10,//每页多少行
          //ChapterID:this.ChapterID,
          ChapterID: this.chapterId,
          TeachingPlanID:this.TeachingPlanId,
          CourseName: '',
          ProvinceID: '',
          CityID: '',
          AreaID: '',
          SchoolID: '',
          SourceType: '',
          TeacherID: '',
          Sort: [
            {SortField: "SharedTime", SortType: "desc"}
          ],
        };
        this.selProvince = '';//省重置
        this.selCity = '';//市重置
        this.selSchool = '';//学校重置
        //过滤器重置
        this.$refs.resourceTable.clearFilter();
        this.getResourceListAuditedBySearchPage();
      },
      //列排序
      resourceTableColumnSort(column, prop, order) {
        switch (column.prop) {
          case "SchoolName":
            this.resourceCondition.Sort[0].SortField = "SchoolID";
            break;
          case "SourceType":
            this.resourceCondition.Sort[0].SortField = "Source";
            break;
          case "ShowState":
            this.resourceCondition.Sort[0].SortField = "State";
            break;
          case "SharedTime":
            this.resourceCondition.Sort[0].SortField = "SharedTime";
            break;
        }
        this.resourceCondition.Sort[0].SortType = column.order == 'ascending' ? 'asc' : 'desc';
        this.getResourceListAuditedBySearchPage();
      },
      //作者,专家,来源,状态 过滤品
      // resourceTableColumnFilter(value) { //筛选只会传递一个value值
      //   console.log("筛选的值:",value);
      //   let tmpArr = value[Object.keys(value)[0]];
      //   this.resourceCondition[tmpArr[0]] = tmpArr.slice(1).join();
      //   this.getResourceListAuditedBySearchPage();
      // },
      /*由原来根据条件筛选, 改为当页筛选*/
      /*resourceTableColumnFilter_SourceType(val,row,column){
        // console.log(val,row,column);
        if(val===1)   return row.SourceType==="云精品";
        return  row.SourceType===""
      },*/
      resourceTableColumnFilter_ShowState(val,row,column){
       //console.log(val,row,column);
        if(val)   return row.ShowState==="已添加";
        return  row.ShowState==="未添加"
      },

      /* 省级开始  , 获取省列表 */
      getProvince(pid) {
        this.axios.post(window.url + 'GetListAreaLvl', {Pid: pid || -1})
          .then(
            res => {

              if (res.data.result === 200) {
                //如果无值, 则为省份
                if (!pid) {
                  let provinceData = res.data.data;
                  // 数据过滤,改变属性名
                  provinceData.filter((val, i, arr) => {
                    val.value = val.CityName;
                    delete val.CityName;
                  });
                  this.provinceData = provinceData;
                } else { //有值则代表市级

                  let cityData = res.data.data;
                  // 数据过滤,改变属性名
                  cityData.filter((val, i, arr) => {
                    val.value = val.CityName;
                    delete val.CityName;
                  });
                  this.cityData = cityData;
                }
              }
            }
          )
      },
      //省输入后的筛选,
      fetchProvinceData(queryStr, callBackFun) {
        // 数组过滤
        let provinceData = this.provinceData.filter((val) => {
          //判断val中是否有queryStr
          if (val.value.indexOf(queryStr) !== -1) {
            return val
          }
        });
        callBackFun(provinceData);
      },
      clearProvinceData() {
        this.resourceCondition.ProvinceID = '';
        this.selCity = '';
        this.selSchool = '';
        this.resourceCondition.CityID = '';
        this.resourceCondition.SchoolID = '';
        this.cityData = [];
        this.schoolData = [];
      },
      //省选择后的修改
      selProvinceData(item) {
        this.resourceCondition.ProvinceID = item.CityCode;
        this.getProvince(item.CityCode);
        this.selCity = '';
        this.selSchool = '';
        this.resourceCondition.CityID = '';
        this.resourceCondition.SchoolID = '';
      },
      /* 省级结束, 获取省列表 */


      /* 市级开始  , 获取市列表 */
      fetchCityData(queryStr, callBackFun) {

        // 数组过滤
        let cityData = this.cityData.filter((val) => {
          //判断val中是否有queryStr
          if (val.value.indexOf(queryStr) !== -1) {
            return val
          }
        });
        callBackFun(cityData);

      },
      clearCityData() {
        this.resourceCondition.CityID = '';
        this.selSchool = '';
        this.resourceCondition.SchoolID = '';
        this.schoolData = [];
      },
      selCityData(item) {

        this.resourceCondition.CityID = item.CityCode;
        this.selSchool = '';
        this.resourceCondition.SchoolID = '';
        this.getSchoolListByArea(item.CityCode);
      },
      /* 市级开始  , 获取市列表 */


      /*学校选择开始*/
      // 获取学校列表
      getSchoolListByArea(Code) {
        this.axios.post(window.url + 'GetSchoolListByArea', {Code: Code})
          .then(
            res => {
              if (res.data.result === 200) {
                //如果无值, 则为省份
                let schoolData = res.data.data;
                // 数据过滤,改变属性名
                schoolData.filter((val, i, arr) => {
                  val.value = val.Name;
                  delete val.Name;
                });
                this.schoolData = schoolData;
              }
            })
      },
      fetchSchoolData(queryStr, callBackFun) {
        // 数组过滤
        let schoolData = this.schoolData.filter((val) => {
          //判断val中是否有queryStr
          if (val.value.indexOf(queryStr) !== -1) {
            return val
          }
        });
        callBackFun(schoolData);
      },
      clearSchoolData() {
        this.resourceCondition.SchoolID = '';
      },
      selSchoolData(item) {
        this.resourceCondition.SchoolID = item.Id;
      },

      /*学校选择结束*/
      downFile(url,name) {
        let index=url.lastIndexOf("/");
        //console.log(url,index,url.substring(index+1));
        //let name=url.substring(index+1);
        const downloadRes = async () => {
          let response = await fetch(url); // 内容转变成blob地址
          let blob = await response.blob();  // 创建隐藏的可下载链接
          let objectUrl = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = objectUrl;
          a.download = name;
          a.click()
          a.remove();
        }
        downloadRes();
      }
    },
    mounted() {
      this.getProvince();//获取省份信息.
      this.getResourceListAuditedBySearchPage();
    }
  }
</script>

<style lang="less" scoped>
  .resource {
    height: 100%;

    .el-row {
      height: 100%;

      .el-col {
        height: 100%;
      }
    }

    h1.title {
      background: #409EFF;
      color: #fff;
      height: 50px;
      font-size: 32px;
      font-weight: bold;
      line-height: 50px;
      margin-bottom: 22px;
    }

    /*搜索条件开始*/

    .condition {
      margin-bottom: 10px;

      .resourceCondition {
        display: flex;

        .el-form-item {
          margin-bottom: 6px;
        }

        .resourceName {
          flex: 1 1 auto;
          margin-right: 12px;
        }

        .resourceBtns {
          width: 160px;
          text-align: right;
        }

        .el-autocomplete {
          display: block;
        }
      }
    }

    .file_li {
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:0 10px;
      .file_yx {
        display: inline-block;
        vertical-align: top;
        margin-right: 20px;
      }
      .file_icon {
        width: 50px;
        min-width: 50px;
        font-size: 11px;
        margin-right: 10px;
        height: 24px;
        line-height: 25px;
        text-align: center;
        display: inline;
        background-color: #5F90FF;
        color: #ffffff;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
      }
      .file_name {
        /*display: block;*/
        margin-right: 40px;
        flex: 1 1 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .file_Mb{
        width:70px;
        min-width: 70px;
        margin-right: 0;
      }
      .file_del {
        width:50px;
        min-width: 50px;
        color: red;
        cursor: pointer;
        float: right;
        margin-right: 0;
        text-align: right;
      }
      .file_down {
        margin-right: 0;
        width:50px;
        min-width: 50px;
        color: #00be00;
        cursor: pointer;
        float: right;
        text-align: right;
      }
    }


    /*搜索条件结束*/

    /deep/ .el-tabs__header {
      .el-tabs__item {
        font-size: 20px;
      }
    }

    .el-table {
      margin-bottom: 10px;
      border: 1px solid #c0c4cc;

      /deep/ td, th {
        padding: 5px 0;
      }

      /deep/ td,
      th,th.is-leaf {
        padding: 5px 0;
        border-bottom: 1px dashed #B0B7C2 !important;
      }

      /deep/ .el-table__row {

      }
    }

    /deep/ .tableHeader {
      background: #F6F6F6;

      th {
        background: #F6F6F6;
        color: #2c3e50;

        .cell.highlight {
          /*background: #F6F6F6;*/
          color: #2c3e50;
        }
      }
    }

    /deep/ .el-table__body {
      tbody {
        tr {
          td:first-child:hover {
            /*text-decoration: underline;*/
            cursor: pointer;
            color: #409EFF;
          }
        }
      }
    }

    .rightVideo{
      position: relative;
      .rVideo {
        position: absolute;
        top:50%;
        left:0;
        right:0;
        transform: translateY(-50%);
        .title {
          font-size: 1.8rem;

        }

        .video {

          video {
            width: 100%;
          }
        }
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/detail/SharedResource.vue